import useStripeExpressWalletSdk from './useStripeExpressWalletSdk';

/**
 * Express Checkout Element wallet config limited to Apple Pay.
 * Other wallets stay disabled so the ECE is the single channel for this method;
 * Google Pay mounts its own ECE instance with its own config.
 */
const APPLE_PAY_PAYMENT_METHODS = {
  applePay: 'always',
  googlePay: 'never',
  link: 'never',
  paypal: 'never',
  amazonPay: 'never',
};

/**
 * useStripeApplePaySdk hook.
 * Thin wrapper over the shared `useStripeExpressWalletSdk` primitive bound to Apple Pay:
 * the ECE is limited to Apple Pay, availability is read from the `applePay` key of the `ready`
 * event, and status/error codes are namespaced with the `apple_pay` prefix.
 *
 * @param {object} props - enabled, amount, currency, appearance, locale, onClick, onConfirm, onCancel, onReady.
 * @returns {object} Apple Pay ECE state and container ref.
 */
function useStripeApplePaySdk(props) {
  return useStripeExpressWalletSdk({
    ...props,
    paymentMethods: APPLE_PAY_PAYMENT_METHODS,
    walletKey: 'applePay',
    errorPrefix: 'apple_pay',
  });
}

export default useStripeApplePaySdk;
